import { useProjectStore } from '../store/projectStore';
import { resolveTrackingBrowserIdsFromInstances } from './batchParametrizationBrowserFlush';

export function registerTorchTrackingBrowserIfApplicable({
  browserId,
  applicationId,
}: {
  browserId: string | undefined;
  applicationId: string | undefined;
}): void {
  if (!browserId || !applicationId) {
    return;
  }

  const { isTrackingEnabled, trackingTargetId, registerTrackingBrowserId } =
    useProjectStore.getState();

  if (!isTrackingEnabled || trackingTargetId !== applicationId) {
    return;
  }

  registerTrackingBrowserId(browserId);
}

export async function syncTorchTrackingBrowsersFromElectron({
  trackingTargetId,
}: {
  trackingTargetId: string | undefined;
}): Promise<void> {
  if (!trackingTargetId) {
    return;
  }

  if (
    typeof window === 'undefined' ||
    !window.electronAPI?.browser?.getInstances
  ) {
    return;
  }

  const { trackingBrowserIds: idsBeforeAwait } = useProjectStore.getState();

  try {
    const result = await window.electronAPI.browser.getInstances();
    if (!result.success || !result.data?.instances) {
      return;
    }

    const {
      isTrackingEnabled,
      trackingTargetId: currentTrackingTargetId,
      reconcileTrackingBrowserIdsFromElectronSync,
    } = useProjectStore.getState();

    if (!isTrackingEnabled || currentTrackingTargetId !== trackingTargetId) {
      return;
    }

    const idsFromElectron = resolveTrackingBrowserIdsFromInstances({
      instances: result.data.instances,
      trackingTargetId,
    });

    reconcileTrackingBrowserIdsFromElectronSync({
      idsBeforeAwait,
      idsFromElectron,
    });
  } catch (error) {
    console.warn(
      '[Terra] Failed to sync TORCH tracking browser ids from Electron',
      error,
    );
  }
}
